import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import * as React from "react";

interface Props {
  inputLabel: string;
  value: any;
  items: { label: string; value: any }[];
  noneSelectedText?: string;
  helperText?: string;
  onChange: (event: React.ChangeEvent<{ value: any }>) => void;
  disabled?: boolean;
}

class SelectMenu extends React.Component<Props> {
  public render() {
    return (
      <FormControl style={{ minWidth: 100 }}>
        <InputLabel>{this.props.inputLabel}</InputLabel>
        <Select
          disabled={this.props.disabled}
          value={this.props.value}
          onChange={this.props.onChange}
        >
          <MenuItem value="">
            <em>{this.props.noneSelectedText || "Keine Auswahl"}</em>
          </MenuItem>
          {this.props.items.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{this.props.helperText}</FormHelperText>
      </FormControl>
    );
  }
}

export default SelectMenu;



// WEBPACK FOOTER //
// ./src/components/generic/SelectMenu.tsx